exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".switch-box{display:flex;border-right:1px dashed #e7eaec;justify-content:center}.switch-box:last-child{border-right:0}.switch-box label{margin-right:20px}", ""]);

